/**
 * Create a new union type of T and the intrinsic attributes of the given element.
 *
 * e.g. ForwardProps<T, 'button'> is equivalent to T & Omit<React.HTMLButtonAttributes<HTMLButtonElement>, keyof T>
 */

// Add new mappings when necessary
var ForwardComponentMap = {
  button: 'Button',
  a: 'Link'
};
function getMappedComponent(key) {
  return key in ForwardComponentMap ? ForwardComponentMap[key] : undefined;
}
export function getComponentDisplayName(component, baseName) {
  var displayName = typeof component === 'string' ? getMappedComponent(component) : component.displayName;
  if (!displayName) {
    displayName = baseName;
  } else if (!displayName.startsWith(baseName)) {
    displayName = "".concat(baseName).concat(displayName);
  }
  return displayName;
}